import { cn } from '@/lib/utils';

/* shadcn/ui Skeleton with the Hangar shimmer (styles/motion.css `.skeleton`, off under reduced motion). */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" aria-hidden className={cn('skeleton rounded-md', className)} {...props} />;
}

export { Skeleton };
